import { createSlice } from '@reduxjs/toolkit';

const ratingsSlice = createSlice({
  name: 'ratings',
  initialState: {
    ratingsCache: {}, // { userId: [rating objects] }
    loading: {}, // { userId: boolean }
    userIdsToLoad: [], // array of user IDs to preload ratings for
  },
  reducers: {
    setRatingsCache: (state, action) => {
      const { userId, ratings } = action.payload;
      state.ratingsCache[userId] = ratings;
    },
    setRatingsLoading: (state, action) => {
      const { userId, loading } = action.payload;
      state.loading[userId] = loading;
    },
    addRating: (state, action) => {
      const { userId, rating } = action.payload;
      if (!state.ratingsCache[userId]) {
        state.ratingsCache[userId] = [];
      }
      state.ratingsCache[userId].unshift(rating);
    },
    updateRating: (state, action) => {
      const { userId, ratingId, rating } = action.payload;
      if (state.ratingsCache[userId]) {
        const index = state.ratingsCache[userId].findIndex(r => r.id === ratingId);
        if (index !== -1) {
          state.ratingsCache[userId][index] = rating;
        }
      }
    },
    setUserIdsToLoad: (state, action) => {
      state.userIdsToLoad = action.payload;
    },
  },
});

export const { setRatingsCache, setRatingsLoading, addRating, updateRating, setUserIdsToLoad } = ratingsSlice.actions;
export default ratingsSlice.reducer;
